import { render } from "./SectionFeaturesTabButton.vue?vue&type=template&id=3937c3fe&scoped=true"
import script from "./SectionFeaturesTabButton.vue?vue&type=script&lang=js"
export * from "./SectionFeaturesTabButton.vue?vue&type=script&lang=js"

import "./SectionFeaturesTabButton.vue?vue&type=style&index=0&id=3937c3fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3937c3fe"]])

export default __exports__